import styled from 'styled-components';

import Typography from '@components/basics/typography';

const StyledError = styled(Typography).attrs(() => ({
  type: 'small',
  weight: '700',
}))`
  position: absolute;
  top: 10px;
  right: 18px;
  text-align: right;
  pointer-events: none;
  color: ${({ theme }) => theme.colors.error};

  @media ${({ theme }) => theme.device.laptopXL} {
    top: 12px;
  }
`;

export default StyledError;
